import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { selectIsLogged, selectMaintenance } from '../slice/selectors';
import { useGlobalFunction } from './useGlobalFunction';
import { MAINTENANCE } from '../slice';
import useMaintenanceCountdown from './useMaintenanceCountdown';
import { NOT_SHOW_MAINTEANCE_REMINDER } from 'utils/constants';

const NO_DISPLAY_REMINDER_PAGES = ['/payment-callback'];

const useMaintenance = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { data: maintenanceData, displayReminder } =
    useSelector(selectMaintenance);
  const isLogged = useSelector(selectIsLogged);
  const { onSetDisplayMaintenanceReminder } = useGlobalFunction();
  const history = useHistory();
  const isDisplayedReminderAtFirstTime = useRef(false);

  const isLoadedMaintenanceData = !!maintenanceData;

  const { isTimeout: isFirstReminderTimeout } = useMaintenanceCountdown({
    time: maintenanceData?.notifyFirstTime ?? 0,
  });
  const { isTimeout: isSecondReminderTimeout } = useMaintenanceCountdown({
    time: maintenanceData?.notifySecond ?? 0,
  });
  const { isTimeout: isEndMaintainTimeout } = useMaintenanceCountdown({
    time: maintenanceData?.endMaintain ?? 0 + 1, // +1s
  });

  useEffect(() => {
    if (pathname !== '/maintenance') dispatch(MAINTENANCE());
  }, [dispatch, pathname]);

  useEffect(() => {
    const getDisplayReminder = () => {
      if (!isLogged || !isLoadedMaintenanceData) return false;

      if (
        sessionStorage.getItem(NOT_SHOW_MAINTEANCE_REMINDER) ||
        NO_DISPLAY_REMINDER_PAGES.includes(pathname)
      ) {
        sessionStorage.removeItem(NOT_SHOW_MAINTEANCE_REMINDER);
        return false;
      }

      if (!maintenanceData.upComingMaintain) return false;

      if (!isDisplayedReminderAtFirstTime.current) {
        isDisplayedReminderAtFirstTime.current = true;
        return true;
      }

      if (isFirstReminderTimeout || isSecondReminderTimeout) return true;

      return false;
    };

    if (getDisplayReminder()) {
      onSetDisplayMaintenanceReminder(true);
    }
  }, [
    isFirstReminderTimeout,
    isLoadedMaintenanceData,
    isLogged,
    isSecondReminderTimeout,
    maintenanceData?.upComingMaintain,
    onSetDisplayMaintenanceReminder,
  ]);

  useEffect(() => {
    if (isEndMaintainTimeout && maintenanceData?.isMaintain) {
      history.push('/');
    }
  }, [isEndMaintainTimeout, maintenanceData?.isMaintain, history]);

  return {
    displayReminder,
  };
};

export default useMaintenance;
